import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { MetricSelectorService } from '../../../../../../../reusables/metric-selector/metric-selector.service';
import { MetricSelectorComponent } from '../../../../../../../reusables/metric-selector/metric-selector.component';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
  selector: 'cv-configure-qualifier',
  templateUrl: './configure-qualifier.component.html',
  styleUrls: ['./configure-qualifier.component.scss']
})
export class ConfigureQualifierComponent implements OnInit {
  @Input() step: number;
  @Input() componentOptions: any;

  gs = null;
  metricsSource: string = "General Choose Qualifier";
  qualifierType: string = "";
  qualifierLeft: string;
  qualifierRight: string;
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    private formattedMetricPipe: GenericMetricFormatterPipe,
    private cdRef: ChangeDetectorRef,
    public metricSelectorService: MetricSelectorService,
    public cvConfigurationService: CvConfigurationService,
  ) {
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    this.gs.modified.item.QualifierLevels = this.gs.modified.item.QualifierLevels || {
      leftNumber: "0",
      rightNumber: "0",
      comparerType: "1"
    };

    if (this.gs.modified.item.Qualifier != undefined) {
        this.initializeQualifierVariables();
    }
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  initializeQualifierVariables(): void {
    const conversionType = this.gs.modified.item.Qualifier.conversionType;

    //Since the backend uses int fields, toString it so the input box will model to it correctly
    this.gs.modified.item.QualifierLevels.comparerType = this.gs.modified.item.QualifierLevels.comparerType.toString();
    this.qualifierType = this.getMetricType();

    if (conversionType == 4 || conversionType == 5) {
      this.qualifierLeft = this.formattedMetricPipe.transform(this.gs.modified.item.QualifierLevels['leftNumber'], conversionType);
      this.qualifierRight = this.formattedMetricPipe.transform(this.gs.modified.item.QualifierLevels['rightNumber'], conversionType);
    } else {
      this.qualifierLeft = this.gs.modified.item.QualifierLevels['leftNumber'];
      this.qualifierRight = this.gs.modified.item.QualifierLevels['rightNumber'];
    }

    this.formatOnBlur('left');
    this.formatOnBlur('right');
  }

  launchMetricSelector(): void {
      let selectedMetric = null;
      if (this.gs.modified.item.Qualifier) {
          const existingMetric = this.gs.modified.item.Qualifier;
          selectedMetric =
          {
              mID: existingMetric.metricID,
              mAbr: existingMetric.abbrev,
              mName: existingMetric.name,
              mDir: existingMetric.direction,
              mCT: existingMetric.conversionType,
          };
      }

      //needed to filter metrics based on game type
      this.metricSelectorService.filterParams = this.gamesService.getGameTypeMetricFilter(this.gs.modified.item.definition.GameType);

      const metricSelector = this.metricSelectorService.openModalForSingleMetric(MetricSelectorComponent, selectedMetric);
      let newQualifier = null;
      metricSelector.result.then((metricSelectorResult) => {
          if (metricSelectorResult) {
            newQualifier = {
                metricID: metricSelectorResult[0].MetricID,
                abbrev: metricSelectorResult[0].Abbreviation,
                name: metricSelectorResult[0].MetricName,
                conversionType: metricSelectorResult[0].ConversionType,
                direction: metricSelectorResult[0].Direction,
            };
            this.gs.modified.item.Qualifier = newQualifier;
            this.onMetricClicked();
          }
      });
  }

  private onMetricClicked(){
    this.qualifierType = this.getMetricType();
    this._resetAndFormatFields();
    this.cdRef.detectChanges();
  }

  getMetricType(): string {
    if (this.gs.modified != null && this.gs.modified.item != null && this.gs.modified.item.Qualifier != null) {
      switch (this.gs.modified.item.Qualifier.conversionType) {
        case "1": return "sec";
        case "2": return "min";
        case "3": return "hr";
        case "4": return "time";
        case "5": return "%";
      }
    }

    return "";
  }

  removeQualifier(): void {
    this.gs.modified.item.Qualifier = null;
  }

  formatOnBlur(side: string): void {
    let property = side == 'left' ? 'leftNumber' : 'rightNumber';
    let setTo: number | string = side == 'left' ? this.qualifierLeft : this.qualifierRight;
    setTo = setTo.replace("%", "");
    if (this.gs.modified.item.Qualifier.conversionType == 4) {
        setTo = this.getTimeInSeconds(setTo.toString());
    }
    else if (this.gs.modified.item.Qualifier.conversionType == 5) {
      setTo = +setTo/100;
    }

    setTimeout(() => {
      this.gs.modified.item.QualifierLevels[property] = this.gs.modified.item.QualifierLevels[property] == 1 ? 0 : 1; //set the value to something it is not set to right now.
      setTimeout(() => {
        this.gs.modified.item.QualifierLevels[property] = setTo;

        if (side == 'left')
          this.qualifierLeft = this.formattedMetricPipe.transform(+setTo, this.gs.modified.item.Qualifier.conversionType);
        else            
          this.qualifierRight = this.formattedMetricPipe.transform(+setTo, this.gs.modified.item.Qualifier.conversionType);
      }, 0);
    }, 0);
  }

  _resetAndFormatFields(): void {
    const _zero = this.formattedMetricPipe.transform(0, this.gs.modified.item.Qualifier.conversionType);
    
    this.gs.modified.item.QualifierLevels.leftNumber = 0;
    this.gs.modified.item.QualifierLevels.rightNumber = 0;

    this.qualifierLeft = _zero;
    this.qualifierRight = _zero;

    this.formatOnBlur('left');
    this.formatOnBlur('right');
  }

  getTimeInSeconds (value: string) {
    const valueSplited = value.split(":").map(v => +v);
    let i = valueSplited.length - 3;

    const hour = +valueSplited[i] || 0;
    const minutes = +valueSplited[++i] || 0;
    const seconds = +valueSplited[++i] || 0;
    return hour * 3600 + minutes * 60 + seconds;
  }

  isQualifierSelected(): boolean {
    if (this.gs.modified.item.Qualifier != null && this.gs.modified.item.Qualifier != undefined) {
      return true;
    } else {
      return false;
    }
  }
}
